(() => {
    /* Hover intent for the desktop header: open after a short pause, close after a short grace period. Click and keyboard always work. */
    const OPEN_DELAY = 180, CLOSE_DELAY = 280;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    const anyOpen = (except) => Array.from(document.querySelectorAll('.header [open]')).some((el) => el !== except);

    /* qa-fix: menu images are rendered as <img data-ntl-src data-ntl-srcset> and only get a real src when their panel,
       drawer or search first opens, so nothing in the menus downloads on page load. Without JS those panels cannot open,
       so there is nothing to fall back to. */
    if (!window.ntlHydrate) {
      window.ntlHydrate = (root) => {
        if (!root || !root.querySelectorAll) return;
        root.querySelectorAll('template[data-ntl-defer]').forEach((tpl) => { tpl.replaceWith(tpl.content.cloneNode(true)); });
        root.querySelectorAll('img[data-ntl-src]').forEach((img) => {
          if (img.dataset.ntlSrcset) { img.srcset = img.dataset.ntlSrcset; img.removeAttribute('data-ntl-srcset'); }
          img.src = img.dataset.ntlSrc; img.removeAttribute('data-ntl-src');
        });
      };
      /* drawers and the search drawer (Impact dialogs) and any <details>/panel get the open attribute when shown */
      new MutationObserver((list) => {
        list.forEach((m) => { if (m.target.hasAttribute && m.target.hasAttribute('open')) window.ntlHydrate(m.target); });
      }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
      /* round 18b: the empty-cart suggestion tiles are deferred too; the drawer gets [open] when shown (above), and when its
         content is re-rendered while it is open (last item removed) this fills them in */
      const ntlCartWatch = () => {
        const cd = document.getElementById('cart-drawer');
        if (!cd) return;
        new MutationObserver(() => { if (cd.hasAttribute('open')) window.ntlHydrate(cd); }).observe(cd, { childList: true, subtree: true });
      };
      document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ntlCartWatch, { once: true }) : ntlCartWatch();
      /* start a little earlier: the tap on the menu / search button itself */
      document.addEventListener('click', (e) => {
        const t = e.target.closest && e.target.closest('[aria-controls="header-sidebar-menu"], [aria-controls="search-drawer"]');
        if (!t) return;
        if (t.getAttribute('aria-controls') === 'search-drawer' && window.__ntlFitSearch) window.__ntlFitSearch();
        window.ntlHydrate(document.getElementById(t.getAttribute('aria-controls')));
      }, true);
    }

    /* qa-fix: below the desktop breakpoint the search is the 680px side panel (also at 1000-1149, where Impact would
       otherwise switch to the full-width box); the full-width layout starts with the desktop nav at 1150 */
    const wide = window.matchMedia('(min-width: 1150px)');
    const fitSearch = () => {
      const d = document.getElementById('search-drawer');
      if (!d) return;
      if (d.dataset.ntlFull === undefined) d.dataset.ntlFull = d.classList.contains('search-drawer--full') ? '1' : '0';
      if (d.dataset.ntlFull === '1') d.classList.toggle('search-drawer--full', wide.matches);
    };
    window.__ntlFitSearch = fitSearch;
    wide.addEventListener ? wide.addEventListener('change', fitSearch) : wide.addListener(fitSearch);

    if (!window.customElements.get('ntl-mega')) {
      class NtlMega extends HTMLElement {
        connectedCallback() {
          /* the element is upgraded as soon as its start tag is parsed, so wait for its children */
          if (this._ready) return;
          if (!this.querySelector('.ntl-mega__panel')) { document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true }); return; }
          this._ready = true;
          this.toggleBtn = this.querySelector('.ntl-mega__toggle');
          this.card = this.closest('.header__wrapper');
          this.dim = document.querySelector('.ntl-mega-dim');
          /* qa-fix: start fetching this panel's images on the first hover / focus, before the open delay ends */
          this.addEventListener('pointerenter', () => window.ntlHydrate(this), { once: true });
          this.addEventListener('focusin', () => window.ntlHydrate(this), { once: true });
          this.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse' || !fine.matches) return;
            clearTimeout(this._close);
            if (!this.hasAttribute('open')) this._open = setTimeout(() => this.setOpen(true), anyOpen(this) ? 0 : OPEN_DELAY);
          });
          this.addEventListener('pointerleave', (e) => {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(this._open);
            /* round 18b: a slow move across the gaps inside the header card (label to panel, label to label) gets more grace */
            const inCard = this.card && e.relatedTarget && this.card.contains(e.relatedTarget);
            this._close = setTimeout(() => this.setOpen(false), inCard ? 600 : CLOSE_DELAY);
          });
          const closeBtn = this.querySelector('.ntl-mega__close');
          if (closeBtn) closeBtn.addEventListener('click', (e) => { e.stopPropagation(); clearTimeout(this._open); this.setOpen(false); this.toggleBtn.focus({ preventScroll: true }); });
          this.toggleBtn.addEventListener('click', (e) => {
            clearTimeout(this._open);
            /* a pointer click on an already open panel follows the top-level link; keyboard (detail 0) just toggles */
            if (e.detail > 0 && this.hasAttribute('open') && fine.matches && this.toggleBtn.dataset.url) {
              window.location.href = this.toggleBtn.dataset.url;
              return;
            }
            this.setOpen(!this.hasAttribute('open'));
          });
          this.addEventListener('focusout', (e) => { if (e.relatedTarget && !this.contains(e.relatedTarget)) this.setOpen(false); });
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.hasAttribute('open')) { this.setOpen(false); this.toggleBtn.focus(); }
          });
          document.addEventListener('click', (e) => { if (this.hasAttribute('open') && !this.contains(e.target)) this.setOpen(false); });
          if (this.card) {
            this.card.addEventListener('toggle', (e) => { if (e.target !== this && e.target.tagName === 'DETAILS' && e.target.open) this.setOpen(false); }, true);
          }
          if (window.Shopify && Shopify.designMode) {
            this.addEventListener('shopify:block:select', () => this.setOpen(true));
            this.addEventListener('shopify:block:deselect', () => this.setOpen(false));
          }
        }
        setOpen(value) {
          if (value === this.hasAttribute('open')) return;
          const others = this.card ? Array.from(this.card.querySelectorAll('ntl-mega[open]')).filter((m) => m !== this) : [];
          if (value && others.length && this.card) {
            /* moving from one panel to the next swaps the content inside the open card instead of folding it shut */
            this.card.classList.add('ntl-mega-swap');
            others.forEach((m) => { clearTimeout(m._close); m.setOpen(false); });
            requestAnimationFrame(() => requestAnimationFrame(() => this.card && this.card.classList.remove('ntl-mega-swap')));
          }
          this.toggleAttribute('open', value);
          this.toggleBtn.setAttribute('aria-expanded', value ? 'true' : 'false');
          const stillOpen = value || (this.card && this.card.querySelector('ntl-mega[open]'));
          this.card && this.card.classList.toggle('ntl-mega-is-open', !!stillOpen);
          if (this.dim) {
            if (!stillOpen && this.dim.classList.contains('is-on')) {
              this.dim.classList.add('is-fading');
              clearTimeout(this.dim._ntlFade);
              this.dim._ntlFade = setTimeout(() => this.dim.classList.remove('is-fading'), 260);
            }
            this.dim.classList.toggle('is-on', !!stillOpen);
          }
          if (value) {
            window.ntlHydrate(this);
            this.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));
            if (this.card) this.card.querySelectorAll('details[open]').forEach((d) => { d.open = false; });
          }
        }
      }
      window.customElements.define('ntl-mega', NtlMega);
    }

    /* Same intent timing for any remaining small dropdowns, which run in Impact's click mode */
    const wireDropdowns = () => {
      document.querySelectorAll('.header details[data-ntl-intent]').forEach((d) => {
        if (d._ntlWired) return;
        d._ntlWired = true;
        let openT, closeT;
        d.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || !fine.matches) return;
          clearTimeout(closeT);
          if (!d.open) openT = setTimeout(() => { d.open = true; d._ntlHover = true; }, anyOpen(d) ? 0 : OPEN_DELAY);
        });
        d.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(openT);
          closeT = setTimeout(() => { d.open = false; d._ntlHover = false; }, CLOSE_DELAY);
        });
        d.addEventListener('click', (e) => {
          const summary = e.target.closest('summary');
          if (!summary || summary.parentElement !== d) return;
          clearTimeout(openT);
          if (e.detail > 0 && d.open && d._ntlHover && summary.dataset.url) {
            e.preventDefault(); e.stopImmediatePropagation();
            window.location.href = summary.dataset.url;
          }
        }, true);
      });
    };

    /* Round 5 grid: size the gutters so column 2 ends exactly on the logo's left edge. With four equal columns c and
       equal gaps g over width W from x = L: column 2 ends at L + W/2 - g/2, so g = W + 2L - 2 * logoLeft. */
    const fitGrid = () => {
      if (window.innerWidth < 1150) return;
      const logo = Array.from(document.querySelectorAll('.header__logo-image, .header__logo-text, .header__logo')).find((el) => el.getBoundingClientRect().width > 0);
      if (!logo) return;
      const lx = logo.getBoundingClientRect().left;
      document.querySelectorAll('.ntl-mega__grid').forEach((grid) => {
        const r = grid.getBoundingClientRect();
        if (!r.width) return;
        const g = Math.round((r.width + 2 * r.left - 2 * lx) * 10) / 10;
        if (g >= 24 && g <= 120) grid.style.setProperty('--ntl-gap', g + 'px'); else grid.style.removeProperty('--ntl-gap');
      });
    };
    let fitT;
    window.addEventListener('resize', () => { cancelAnimationFrame(fitT); fitT = requestAnimationFrame(fitGrid); });
    window.addEventListener('load', fitGrid);
    document.addEventListener('pointerover', (e) => { if (e.target.closest && e.target.closest('.ntl-mega')) fitGrid(); }, { passive: true });
    document.addEventListener('focusin', (e) => { if (e.target.closest && e.target.closest('.ntl-mega')) fitGrid(); });

    /* Mobile / tablet (round 5): no override, Impact opens its own floating bottom sheet as on the live theme */
    const onReady = () => { wireDropdowns(); fitGrid(); fitSearch(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
    document.addEventListener('shopify:section:load', onReady);

    /* Measurement hooks: forward nav clicks to PostHog only if it is already on the page (no new libraries) */
    if (!window.__ntlNavTracking) {
      window.__ntlNavTracking = true;
      document.addEventListener('click', (e) => {
        const el = e.target.closest && e.target.closest('[data-ntl-nav]');
        if (!el || !window.posthog || typeof window.posthog.capture !== 'function') return;
        const raw = el.getAttribute('data-ntl-nav') || '';
        const i = raw.indexOf(':');
        const area = i > -1 ? raw.slice(0, i) : raw;
        const props = { area, label: i > -1 ? raw.slice(i + 1) : '', href: el.getAttribute('href') || null, path: window.location.pathname };
        try {
          window.posthog.capture(area.indexOf('search-') === 0 ? 'search_featured_click' : 'nav_click', props);
        } catch (err) {}
      }, true);
    }
  })();
